import React from 'react';
import { Search } from 'lucide-react';
import { Input } from '../ui/input';

const Header = ({ title }) => {
  return (
    <header 
      data-testid="header"
      className="hidden lg:flex sticky top-0 z-30 h-14 items-center justify-between px-6 bg-white/80 dark:bg-[#1a1025]/80 backdrop-blur-sm border-b border-slate-200/50 dark:border-blue-500/10"
    >
      <h1 className="text-lg font-semibold text-slate-900 dark:text-white">{title}</h1>

      <div className="flex items-center gap-4">
        {/* Search */}
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400 dark:text-blue-400/50" />
          <Input
            data-testid="search-input"
            placeholder="Buscar..."
            className="pl-9 w-56 h-9 bg-slate-50 dark:bg-blue-500/10 border-slate-200 dark:border-blue-500/20 dark:text-white dark:placeholder:text-blue-300/40 text-sm"
          />
        </div>
      </div>
    </header>
  );
};

export default Header;
